import React from 'react';
import { BottomCard, BottomCardAction } from '@/components/shared/BottomCard';
import { AsaphButton } from '@/components/shared/Button';
import styles from './SetlistPermissionSheet.module.scss';

interface SetlistPermissionSheetProps {
  open: boolean;
  onClose: () => void;
  onNewMessage: () => void;
}

export const SetlistPermissionSheet: React.FC<SetlistPermissionSheetProps> = ({ open, onClose, onNewMessage }) => {
  if (!open) return null;
  return (
    <BottomCard title="Create setlist" onClose={onClose}>
      <div className={styles['info']}>
        <div className={styles['info__body']}>
          Only admins can create setlists. Message an admin to upgrade your permissions.
        </div>
      </div>
      <BottomCardAction>
        <AsaphButton
          fullWidth
          color="grey"
          label="OK"
          onClick={onClose}
        />
        <AsaphButton
          fullWidth
          color="blue"
          label="New Message"
          onClick={onNewMessage}
        />
      </BottomCardAction>
    </BottomCard>
  );
};
